<template>
  <v-row class="">
    <div class="flow-line">
      <div class="pt-8 flow-line-inside">&nbsp;</div>
    </div>
    <v-card outlined class="mx-auto py-1 px-8" width="100%" elevation="1">
      <v-row class="mx-auto">
        <v-card-title class="mx-auto text-center"
          >What should happen next?</v-card-title
        >
      </v-row>
      <v-row class="">
        <v-col>
          <v-card
            outlined
            class="mx-auto py-2 px-1"
            flat
            width="90"
            @click="clickWhatNext('greeting')"
          >
            <div class="text-center">
              <v-icon color="primary">mdi-account-voice</v-icon>
            </div>
            <div class="text-center primary--text flow-add-step-text">
              Greeting
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            outlined
            class="mx-auto py-2 px-1"
            flat
            width="90"
            @click="clickWhatNext('forward')"
          >
            <div class="text-center">
              <v-icon color="primary">mdi-phone-forward</v-icon>
            </div>
            <div class="text-center primary--text flow-add-step-text">
              Forward
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            outlined
            class="mx-auto py-2 px-1"
            flat
            width="90"
            @click="clickWhatNext('multiring')"
          >
            <div class="text-center">
              <v-icon color="primary">mdi-phone-ring</v-icon>
            </div>
            <div class="text-center primary--text flow-add-step-text">
              Multi-ring
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            outlined
            class="mx-auto py-2 px-1"
            flat
            width="90"
            @click="clickWhatNext('voicemail')"
          >
            <div class="text-center">
              <v-icon color="primary">mdi-voicemail</v-icon>
            </div>
            <div class="text-center primary--text flow-add-step-text">
              Voicemail
            </div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            outlined
            class="mx-auto py-2 px-1"
            flat
            width="90"
            @click="clickWhatNext('ivr')"
          >
            <div class="text-center">
              <v-icon color="primary">mdi-dialpad</v-icon>
            </div>
            <div class="text-center primary--text flow-add-step-text">IVR</div>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            outlined
            class="mx-auto py-2 px-1"
            flat
            width="90"
            @click="clickWhatNext('redirect')"
          >
            <div class="text-center">
              <v-icon color="primary">mdi-redo</v-icon>
            </div>
            <div class="text-center primary--text flow-add-step-text">Redirect</div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: "CallFlowWhatNext",
  components: {},
  props: {
    clickWhatNext: {
      type: Function,
      required: false
    }
  },
  data: function() {
    return {};
  },
  created() {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="stylus">
.call-flow-icon {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
  font-weight: 400;
}
.flow-line {
  height: 3rem;
  width: 100%;
}
.flow-line-inside {
  height: 3rem;
  width: 50%;
  border-right: 1px solid #cccccc;
}
.flow-add-step-text {
  font-size: 0.70rem !important;
  font-weight: 500;
  line-height: 2rem;
  text-transform: uppercase;
  font-family: "Roboto", sans-serif !important;
}
</style>
